import { useNavigate } from "react-router-dom";
import $ from "jquery";
const ListCamera = (props) => {
  const navigate = useNavigate();
  // console.log("sn-ipc", props.dataIpc.serialNumber);
  return (
    <div
      className="modal fade"
      id={`modalCamera-${props.dataIpc.serialNumber}`}
      tabIndex={-1}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Camera</h5>
            <button
              type="button"
              className="close closeModalSetting"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body px-0">
            <table className="table">
              <thead>
                <tr>
                  <th width="20px">No.</th>
                  <th>DDNS</th>
                  <th>User</th>
                  <th>Pass</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {props.dataIpc.ipCams.map((c, o) => {
                  var no = o;
                  c = Object.assign(c, {
                    id: no,
                    idIpc: props.dataIpc.serialNumber,
                  });
                  return (
                    <tr key={o}>
                      <td>{no}</td>
                      <td>{c.ddns}</td>
                      <td>{c.user}</td>
                      <td>{c.pass}</td>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            $(".btnClose").click();
                            navigate("/camera-streaming", {
                              state: { data: c },
                            });
                          }}
                        >
                          Stream
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="modal-footer">
            {/* <button type="button" className="btn btn-danger" onClick={handleUpload}>
                                    Hapus
                                </button> */}
            <button
              type="button"
              className="btn btn-light btnClose"
              data-dismiss="modal"
            >
              Batal
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ListCamera;
